export default class Search {
	constructor() {
		this.node = document.querySelector(".site-search");

		if (!this.node) {
			return;
		}

		this.classes = {
			bodyOpened: "fixed",
			opened: "site-search--opened",
			contentOpened: "site-search__content--opened",
		};

		this.toggleSearch = this.node.querySelector(".toggle-btn--search");
		this.content = this.node.querySelector(".site-search__content");

		if (this.toggleSearch) {
			this.toggleSearch.addEventListener("click", () => {
				if (this.node.classList.contains(this.classes.opened)) {
					// close
					this.close();
				} else {
					// open
					this.open();
				}
			});
		}

		//search close .site-search site-search--opened
		document
			.querySelector(".toggle-btn--menu")
			.addEventListener("click", () => {
				if (this.node.classList.contains(this.classes.opened)) {
					// close
					this.close();
					document.body.classList.add(this.classes.bodyOpened);
				}
			});

		// handle esc/tab keys
		this.handleKeyup = (e) => {
			if (this.opened) {
				if (e.key === "Escape") {
					console.log("escape");
					return this.close();
				}

				if (
					e.key === "Tab" &&
					!document.activeElement.closest(".site-search")
				) {
					console.log("other key close");
					// close the flyout when you tab out of it (if possible)
					return this.close();
				}
			}
		};

		// handle close
		this.node.addEventListener("click", (e) => {
			if (e.target.closest(".site-search")) {
				return;
			}
			console.log("handle close");

			this.close();
		});
	}
	open() {
		console.log("open function");
		// if (mode) {
		// 	this.setMode(mode);
		// }

		this.opened = true;
		this.node.style.display = "block";
		document.body.classList.add(this.classes.bodyOpened);
		document.addEventListener("keyup", this.handleKeyup);

		this.disableTabs();

		this.previousActiveElement = document.activeElement;

		requestAnimationFrame(() =>
			requestAnimationFrame(() => {
				console.log("open function request animation");
				this.node.classList.add(this.classes.opened);
				this.content.classList.add(this.classes.contentOpened);

				// if (this.mode === 'search' && this.searchInput) {
				// 	this.searchInput.focus();
				// } else
				// if ( this.closer ) {
				// 	this.closer.focus();
				// }

				this.node.dispatchEvent(
					new CustomEvent("search:open", { bubbles: true, cancelable: false })
				);
			})
		);
	}
	close() {
		console.log("closign?");
		this.opened = false;
		document.removeEventListener("keyup", this.handleKeyup);
		//const onTransitionEnd = (e) => {
		console.log("close function transitionend");
		//this.content.removeEventListener('transitionend', onTransitionEnd);

		this.node.style.display = "";

		document.body.classList.remove(this.classes.bodyOpened);

		this.node.classList.remove(this.classes.opened);

		if (this.previousActiveElement) {
			this.previousActiveElement.focus();
		}

		this.enableTabs();

		this.node.dispatchEvent(
			new CustomEvent("search:close", { bubbles: true, cancelable: false })
		);
		//}
		console.log("closing2");
		//this.content.addEventListener('transitionend', onTransitionEnd);
		this.content.classList.remove(this.classes.contentOpened);
	}

	getTabs(scope = document) {
		return Array.from(
			scope.querySelectorAll(
				[
					"select",
					"input",
					"textarea",
					"button",
					"a",
					"iframe",
					"object",
					"embed",
					"*[contenteditable]",
					"*[tabindex]",
				].join(", ")
			)
		).filter((node) => {
			return !node.closest(".site-search");
		});
	}

	disableTabs() {
		const tabs = this.getTabs();

		tabs.forEach((node) => {
			let prevTabIndex = node.getAttribute("tabIndex");
			if (prevTabIndex) {
				node.setAttribute("data-tab-index", prevTabIndex);
			}

			node.setAttribute("tabIndex", "-1");
		});

		return tabs;
	}

	enableTabs() {
		const tabs = this.getTabs();

		tabs.forEach((node) => {
			let prevTabIndex = node.getAttribute("data-tab-index");
			if (prevTabIndex) {
				node.setAttribute("tabIndex", prevTabIndex);
				node.removeAttribute("data-tab-index");
			} else {
				node.removeAttribute("tabIndex");
			}
		});

		return tabs;
	}
}
